import { useQuery } from "@tanstack/react-query";
import Api from "src/Config";
import { createContext, FunctionComponent, ReactElement, useMemo } from "react";

export const RiskDetectedContext = createContext(null);

type Props = {
  children: ReactElement;
};

const RiskDetectedProvider: FunctionComponent<Props> = ({ children }) => {
  const { data, isLoading, error, isFetching } = useQuery({
    queryKey: ["risk_detected"],
    staleTime: 30000,
    queryFn: async () => {
      const {
        data: { data },
      } = await Api.get(`overview?keyword=risk-detected`);

      return data;
    },
  });

  const contextValue = useMemo(
    () => ({
      data,
      isLoading,
      isFetching,
      error,
    }),
    [isLoading, data, error, isFetching],
  );
  return (
    <RiskDetectedContext.Provider value={contextValue}>
      {children}
    </RiskDetectedContext.Provider>
  );
};

export default RiskDetectedProvider;
